import { App } from 'vue'
import BasicIcon from '@/components/icon/basic-icon.vue'

export function setupComponent(app: App<Element>) {
  app.component('BasicIcon', BasicIcon)
}
